/* eslint-disable react/no-unused-prop-types */
import React from 'react'

import { Button, ModalBase } from '@components/atoms'
import { modalCreators } from '@store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import moment from 'moment'

import { Header, Items } from './style'

type ModalProps = {
	id: number
	name: string
	meta: {
		pivot_created_at: string
		pivot_expiration_date: string
		pivot_is_lifetime: boolean
	}
}

export const ShowClasses = () => {
	const dispatch = useAppDispatch()

	const {
		modal: { modalName, modalInfo },
	} = useAppSelector((state) => state)

	return (
		<ModalBase title='Turmas' open={modalName === 'showClasses'}>
			<div style={{ overflow: 'scroll' }}>
				<Header>
					<p>Turmas</p>
					<p>Cadastro</p>
					<p>Expiração</p>
				</Header>
				{modalInfo &&
					modalInfo?.classes?.length > 0 &&
					modalInfo?.classes?.map(
						({
							id,
							name,
							meta: {
								pivot_created_at,
								pivot_expiration_date,
								pivot_is_lifetime,
							},
						}: ModalProps) => (
							<Items key={id}>
								<p>{name}</p>
								<p>{moment.utc(pivot_created_at).format('DD/MM/YYYY')}</p>
								<p>
									{pivot_is_lifetime
										? 'Vitalício'
										: moment.utc(pivot_expiration_date).format('DD/MM/YYYY')}
								</p>
							</Items>
						)
					)}
				<div
					style={{
						display: 'flex',
						gap: '26px',
						marginTop: '34px',
						width: '100%',
					}}
					onClick={() => {
						dispatch(modalCreators.closeModal())
					}}
				>
					<Button>OK</Button>
				</div>
			</div>
		</ModalBase>
	)
}
